{
    "label_close-button": "Close"
}
